<h1>Workflow Template Library</h1>

<div class="row">
    <div class="col">
        <div class="float-right">
            <div class="d-inline-block" style="margin-right: 10px;">
                <button
                    class="btn btn-success btn-raised"
                    (click)="createWorkflow()"
                >
                    New Workflow
                </button>
            </div>
            <div class="d-inline-block">
                <button
                    class="btn btn-primary btn-raised"
                    [routerLink]="['../migrate']"
                >
                    Migrate Workflow
                </button>
            </div>
        </div>

            <!--
                *** If we decide to offer a list of jurisdictions/workflows to copy
                *** from into the Template Library, then this can replace the button
                *** above, but it needs a new component to route to (select
                *** jurisdiction and workflow).
            -->
            <!-- <wm-modal-confirm
                #newWorkflow
                buttonText="New Workflow"
                [showButton]="true"
                [showButtonText]="true"
                buttonClass="btn btn-raised btn-success"
            >
                <h2>New Workflow</h2>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <h4>Start from blank</h4>
                                <p>This will create a new blank workflow with just a start activity.</p>
                                <button
                                    type="button"
                                    class="btn btn-raised btn-primary btn-block"
                                    (click)="newWorkflow.accept();createWorkflow()"
                                >
                                    Create Blank
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                        <div class="card">
                            <div class="card-body">
                                <h4>Import From Jurisdiction</h4>
                                <p>This will allow yout to select a workflow from a jurisdiction to use as a starting point.</p>
                                <button
                                    class="btn btn-primary btn-raised btn-block"
                                    (click)="newWorkflow.accept()"
                                    [routerLink]="[''']"
                                >
                                    Select Workflow
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </wm-modal-confirm> -->
    </div>
</div>

<ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
    <li ngbNavItem>
        <a ngbNavLink>Workflows</a>
        <ng-template ngbNavContent>
            <wm-workflow-list
                [workflows]="workflows"
                [loadGlobal]="true"
                [isTemplateLibrary]="true"
                (onArchive)="archiveWorkflow($event)"
                (onDisable)="disableWorkflow($event)"
                (onEnable)="enableWorkflow($event)"
            ></wm-workflow-list>
        </ng-template>
    </li>
    <li ngbNavItem>
        <a ngbNavLink>Archive</a>
        <ng-template ngbNavContent>
            <wm-workflow-list
                [workflows]="archivedWorkflows"
                [loadGlobal]="true"
                [isTemplateLibrary]="true"
                (onRestore)="restoreWorkflow($event)"
            ></wm-workflow-list>
        </ng-template>
    </li>
</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
